import { SpinProps } from 'antd'
import { FC } from 'react'

import { SC_Spin } from './styles'

export type T_SpinProps = SpinProps
export const Spin: FC<T_SpinProps> = ({
  children,
  ...restProps
}) => (
  <SC_Spin {...restProps}>
    {children}
  </SC_Spin>
)
